// Web 版本人確認の API クライアント
// アプリ版 src/api/TunagateAPI.js の identificationCompareFaces / identificationRegisterProfile と同等。
// CSRF はサーバー側で全体 skip されているが、念のため meta タグから token を渡す。

const csrfToken = () => {
  if (typeof document === 'undefined') {
    return '';
  }
  const meta = document.getElementsByName('csrf-token')[0];
  return meta ? meta.content : '';
};

const handleResponse = async (response) => {
  // バックエンド側が 404/500 等を返す場合があるので JSON parse 前に check
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }
  return response.json();
};

export const compareFaces = async ({ frontImage, backImage, selfieImage }) => {
  const formData = new FormData();
  formData.append('official_identification_front', frontImage, 'front.jpg');
  if (backImage) {
    formData.append('official_identification_back', backImage, 'back.jpg');
  }
  formData.append('selfie', selfieImage, 'selfie.jpg');

  const response = await fetch('/api/user/identification/compare_faces', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'X-CSRF-Token': csrfToken(),
    },
    body: formData,
  });
  return handleResponse(response);
};

export const registerProfile = async ({
  familyName,
  firstName,
  familyNameKana,
  firstNameKana,
  isFullNameHidden,
  student,
}) => {
  const body = {
    familyname: familyName,
    firstname: firstName,
    familyname_kana: familyNameKana,
    firstname_kana: firstNameKana,
    is_fullname_hidden: isFullNameHidden ? 'true' : 'false',
    student: student
      ? {
          school_name: student.schoolName,
          birthdate: student.birthdate,
          enrolled_at: student.enrolledAt,
          academic_years: student.academicYears,
        }
      : null,
  };

  const response = await fetch('/api/user/identification/profile', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken(),
    },
    body: JSON.stringify(body),
  });
  return handleResponse(response);
};
